export const ShopperAgentOutreachOrigin = {
  Campaign: "campaign",
  Automation: "automation",
  OutreachAgent: "outreach_agent",
  /** The shopper texted first, from the customer portal. */
  CustomerPortal: "customer_portal",
  /** The shopper texted first, unprompted. */
  CustomerInitiated: "customer_initiated",
} as const;

export type ShopperAgentOutreachOrigin =
  (typeof ShopperAgentOutreachOrigin)[keyof typeof ShopperAgentOutreachOrigin];

/** The customer initiated the conversation; no merchant message started it. */
export function isCustomerInitiatedOutreachOrigin(
  origin: ShopperAgentOutreachOrigin | null,
): boolean {
  return (
    origin === ShopperAgentOutreachOrigin.CustomerPortal ||
    origin === ShopperAgentOutreachOrigin.CustomerInitiated
  );
}

/** campaign > automation provenance > outreach_agent (settings/sentinel). */
export function classifyShopperAgentOutreachOrigin(input: {
  readonly campaignId?: string | null;
  readonly automationId?: string | null;
  readonly automationStepId?: string | null;
  readonly recoverConfigId?: string | null;
}): ShopperAgentOutreachOrigin {
  if (input.campaignId) {
    return ShopperAgentOutreachOrigin.Campaign;
  }
  if (input.automationId || input.automationStepId || input.recoverConfigId) {
    return ShopperAgentOutreachOrigin.Automation;
  }
  return ShopperAgentOutreachOrigin.OutreachAgent;
}
